// extracted by mini-css-extract-plugin
export var gif = "_l8-0";